module.exports = __webpack_public_path__ + "img/zampay.e9473a27.png";